module.exports = __webpack_public_path__ + "static/media/Harshwardhan_Deshmukh.5d2a56d5.jpg";